import { Deployment, TrajectoryInfo } from '../types/types';

export const knownTrajectoryColors: Record<
  'red' | 'blue' | 'green' | 'yellow' | 'orange' | 'magenta',
  string
> = {
  red: '#ff0000',
  blue: '#0000ff',
  green: '#228B22',
  yellow: '#ffff00',
  orange: '#ff8000',
  magenta: '#ff00ff',
};

export const colorNames: Record<
  'red' | 'blue' | 'green' | 'yellow' | 'orange' | 'magenta',
  string
> = {
  red: 'Red',
  blue: 'Blue',
  green: 'Green',
  yellow: 'Yellow',
  orange: 'Orange',
  magenta: 'Magenta',
};

export function findTrajectoryByColor(
  deployment: Deployment,
  targetColor: string
): TrajectoryInfo | undefined {
  return deployment.trajectories.find(
    (trajectory) => trajectory.color === targetColor
  );
}

export const extractColorFromFilename = (fileName: string): string => {
  const matchedColor = Object.keys(knownTrajectoryColors).find((color) =>
    fileName.toLowerCase().startsWith(color)
  );
  return matchedColor || 'red';
};
